<template>
  <div class="category category-simple">
    <div class="category-title">
      <h3 class="tc-title">{{ category.name }}</h3>
      <div class="right-container">
        <div v-if="hasLegIntToggle" class="switch-container">
          <label v-if="settings.iabLegitimateInterestToggle">{{ $t('legitimateInterest') }}</label>
          <span v-if="showDetailsLink" class="nb-vendors"
            >(<a
              class="pointer"
              v-if="$listeners['show-related-vendors']"
              @click="showRelatedVendors('legIntPurposes')"
              >{{ $t('nbVendors', { nbVendors: countLegIntVendors }) }}</a
            >)</span
          >
          <pc-checkbox-button
            v-if="settings.consentButtonStyle === 'button'"
            v-model="category.legitimateInterest"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-checkbox-button>
          <pc-checkbox-native
            v-else-if="settings.consentButtonStyle === 'checkbox'"
            v-model="category.legitimateInterest"
            @input="emitConsentChanged"
          ></pc-checkbox-native>
          <pc-leg-switch
            v-else
            v-model="category.legitimateInterest"
            :settings="settings"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-leg-switch>
        </div>
        <div v-if="!noConsent && hasConsentToggle" class="switch-container">
          <label v-if="settings.iabLegitimateInterestToggle">{{ $t('consent') }}</label>
          <span v-if="showDetailsLink" class="nb-vendors"
            >(<a class="pointer" v-if="$listeners['show-related-vendors']" @click="showRelatedVendors('purposes')">{{
              $t('nbVendors', { nbVendors: countConsentVendors })
            }}</a
            >)</span
          >
          <pc-checkbox-button
            v-if="settings.consentButtonStyle === 'button'"
            v-model="category.consent"
            :aria-label="category.label"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-checkbox-button>
          <pc-checkbox-native
            v-else-if="settings.consentButtonStyle === 'checkbox'"
            v-model="category.consent"
            @input="emitConsentChanged"
          ></pc-checkbox-native>
          <pc-leg-switch
            v-else
            v-model="category.consent"
            :settings="settings"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-leg-switch>
        </div>
      </div>
    </div>
    <p class="category-description tc-description">{{ category.description }}</p>
    <div class="consent-footer">
      <a v-if="showDetailsLink" class="pointer" style="align-items:flex-end;" @click="displayLegal = !displayLegal">
        <span v-if="category.descriptionLegal">{{ $t('legals') }}</span>
        <span v-if="filteredIllustrations.length > 0">{{ $t('examples') }}</span>
        <span v-show="displayLegal" class="glyphicon glyphicon-chevron-up" aria-hidden="true"></span>
        <span v-show="!displayLegal" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
      </a>
      <a class="pointer" v-if="$listeners['show-related-vendors']" @click="showRelatedVendors()">
        {{ settings.showRelatedVendorsText || $t('showRelatedVendors') }}
      </a>
    </div>
    <div v-if="category.descriptionLegal" class="description-legal" v-show="displayLegal">
      <p>{{ category.descriptionLegal }}</p>
    </div>
    <div v-if="filteredIllustrations.length > 0" class="description-examples" v-show="displayLegal">
      <p v-for="example in filteredIllustrations" :key="example">
        {{ example }}
      </p>
    </div>
  </div>
</template>
<script>
import PcCheckboxButton from '@/components/forms/pc-checkbox-button';
import PcLegSwitch from '@/components/forms/pc-leg-switch';
import PcCheckboxNative from '@/components/forms/pc-checkbox-native';

import { i18nMixin } from 'shared/i18n/i18n-mixin';
import { eventEmitterMixin } from '@/common/messaging/event-emitter-mixin';
import { stripHtml } from '@/common/filters/strip-html';

export default {
  components: {
    PcCheckboxButton,
    PcLegSwitch,
    PcCheckboxNative,
  },
  mixins: [i18nMixin, eventEmitterMixin],

  props: {
    category: {
      type: Object,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    noConsent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      displayLegal: false,
    };
  },
  computed: {
    countConsentVendors() {
      return Object.values(this.settings.iabItemsToDisplay.vendors).filter(vendor =>
        vendor.purposes.includes(this.category.id)
      ).length;
    },
    countLegIntVendors() {
      return Object.values(this.settings.iabItemsToDisplay.vendors).filter(vendor =>
        vendor.legIntPurposes.includes(this.category.id)
      ).length;
    },
    filteredIllustrations() {
      if (this.category.illustrations) {
        return this.category.illustrations.filter(i => i.length > 0);
      }

      return [];
    },
    hasConsentToggle() {
      return !this.noConsent && this.category.isConsent;
    },
    hasLegIntToggle() {
      return (
        !this.noConsent &&
        this.category.isLegitimateInterest &&
        (this.settings.iabLegitimateInterestToggle || !this.hasConsentToggle)
      );
    },
    showDetailsLink() {
      return this.category.descriptionLegal || this.filteredIllustrations.length > 0;
    },
  },
  watch: {
    'category.consent': function(value) {
      if (!this.settings.iabLegitimateInterestToggle && !this.hasLegIntToggle && this.category.isLegitimateInterest) {
        this.category.legitimateInterest = value;
      }
    },
  },

  methods: {
    stripHtml,
    showRelatedVendors(consentMode) {
      const params = { category: this.category, provider: 'iab' };
      if (consentMode != null) {
        params.consentMode = consentMode;
      }
      this.$emit('show-related-vendors', params);
    },
  },
};
</script>
<style lang="scss" scoped>
.description-legal,
.description-examples {
  padding: 2rem;
  white-space: pre-line;
}
.consent-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.category {
  margin-bottom: 3rem;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
</style>
